<template>
		<section class="cases">
			<div class="container section-active">
				<div class="row team-margin">
					<div class="col-xs-12 col-sm-4 col-md-4 x-gundong">
						<div class="casesNav" v-for="(item, index) in casesList" :key="index" 
						:class="casesIndex == index ? 'casesNav-active':''" @click="swichToCases(index)">
							{{item}}
						</div>
					</div>
					<div class="col-xs-12 col-sm-8 col-md-8">
						<div class="row" v-if="casesIndex==0">
							<div class="col-xs-6 col-sm-5 col-md-5">
								<img src="../assets/img/product/yzj.png" alt="" class="img-responsive lawyer-img">
							</div>
							<div class="col-xs-12 col-sm-7 col-md-7">
								<p class="lawyer-name">尹志军</p>
								<p class="lawyer">律师</p>
								<p class="lawyer-detail">先后取得法学学士、硕士及博士学位，学习及研究领域为经济法、知识产权法、环境法及法制史，具有深厚的法学理论功底。</p>
								<p class="lawyer-detail">尹志军律师长期负责公司客户的法律顾问服务、参与公司管理及各项制度建设、诉讼、重组及投融资业务等。二十多年来，尹志军律师先后为国内外近百家公司、企业提供了各方面的法律服务，为客户提出切实可行的法律方案及优质的法律服务。尹志军律师的专业领域为公司、矿业能源、投融资、知识产权、合同及争议解决。</p>
							</div>
						</div>
						<!-- <div class="row" v-if="casesIndex==1">
							<div class="col-xs-6 col-sm-5 col-md-5">
								<img src="../assets/img/product/wqy.png" alt="" class="img-responsive lawyer-img">
							</div>
							<div class="col-xs-12 col-sm-7 col-md-7">
								<p class="lawyer-name">王秋玉</p>
								<p class="lawyer">律师</p>
								<p class="lawyer-detail">王秋玉律师毕业于西南政法大学，主修民法、刑法及其诉讼法，取得法学学士学位。</p>
								<p class="lawyer-detail">王秋玉律师主要从事公司、合同、矿权及争议解决等法律事务，特别在矿权实务操作中具有较为丰富的经验。</p>
							</div>
						</div> -->
						<div class="row" v-if="casesIndex==1">
							<div class="col-xs-6 col-sm-5 col-md-5">
								<img src="../assets/img/product/zy.png" alt="" class="img-responsive lawyer-img">
							</div>
							<div class="col-xs-12 col-sm-7 col-md-7">
								<p class="lawyer-name">张延</p>
								<p class="lawyer">律师</p>
								<p class="lawyer-detail">张延律师毕业于西北政法大学，擅长诉讼、执行案件。</p>
							</div>
						</div>
						<!-- <div class="row" v-if="casesIndex==2">
							<div class="col-xs-6 col-sm-5 col-md-5">
								<img src="../assets/img/product/qyx.png" alt="" class="img-responsive lawyer-img">
							</div>
							<div class="col-xs-12 col-sm-7 col-md-7">
								<p class="lawyer-name">覃艳霞</p>
								<p class="lawyer">律师</p>
								<p class="lawyer-detail">覃艳霞律师毕业于中国人民大学，主修民法、商法、诉讼法，取得法学学士学位。</p>
								<p class="lawyer-detail">覃艳霞律师主要从事公司、合同、婚姻家事、知识产权争议解决等法律事务。</p>
							</div>
						</div> -->
						<div class="row" v-if="casesIndex==2">
							<div class="col-xs-6 col-sm-5 col-md-5">
								<img src="../assets/img/product/zcr.png" alt="" class="img-responsive lawyer-img">
							</div>
							<div class="col-xs-12 col-sm-7 col-md-7">
								<p class="lawyer-name">张承瑞</p>
								<p class="lawyer">律师</p>
								<p class="lawyer-detail">张承瑞律师毕业于郑州大学法律系，1999年开始从事律师业务。</p>
								<p class="lawyer-detail">张律师长期从事公司业务、合同业务、企业破产和刑事辩护业务，具有丰富的执业经验。</p>
							</div>
						</div>
						<!-- <div class="row" v-if="casesIndex==5">
							<div class="col-xs-6 col-sm-5 col-md-5">
								<img src="../assets/img/product/ghm.png" alt="" class="img-responsive lawyer-img">
							</div>
							<div class="col-xs-12 col-sm-7 col-md-7">
								<p class="lawyer-name">高华萌</p>
								<p class="lawyer">律师</p>
								<p class="lawyer-detail">高华萌律师毕业于河北经贸大学，主修经济法、民法、商法，取得经济法学硕士学位。</p>
								<p class="lawyer-detail">高华萌律师主要从事公司、合同、知识产权等法律事务。</p>
							</div>
						</div> -->
						<div class="row" v-if="casesIndex==3">
							<div class="col-xs-6 col-sm-5 col-md-5">
								<img src="../assets/img/product/hlw.png" alt="" class="img-responsive lawyer-img">
							</div>
							<div class="col-xs-12 col-sm-7 col-md-7">
								<p class="lawyer-name">黄丽文</p>
								<p class="lawyer">律师</p>
								<p class="lawyer-detail">黄丽文律师毕业于首都师范大学，主修民法、商法、诉讼法，取得宪法学与行政法学法学硕士学位。</p>
								<p class="lawyer-detail">黄丽文律师主要从事公司、合同方面争议解决，以及知识产权领域的法律事务，积累了一定的经验。</p>
							</div>
						</div>
						<!-- <div class="row" v-if="casesIndex==4">
							<div class="col-xs-6 col-sm-5 col-md-5">
								<img src="../assets/img/product/lyw.png" alt="" class="img-responsive lawyer-img">
							</div>
							<div class="col-xs-12 col-sm-7 col-md-7">
								<p class="lawyer-name">刘业伟</p>
								<p class="lawyer">律师</p>
								<p class="lawyer-detail">刘业伟律师毕业于西北政法大学刑事法学院，主修民法、刑法、诉讼法，取得刑法学法学硕士学位。</p>
								<p class="lawyer-detail">刘业伟律师主要从事刑事、公司、合同等方面业务。</p>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</section>
</template>

<script>
export default {
	data () {
		return {
			casesIndex: 0,
			casesList: ['尹志军','张延','张承瑞','黄丽文']
		}
	},
	methods: {
		swichToCases (index) {
			this.casesIndex = index;
		}
	}
}
</script>

<style scoped>
@import url("../assets/css/common.css");
@import url("../assets/css/product.css");
</style>


// WEBPACK FOOTER //
// src/components/team.vue